import React from "react";
import { NavLink } from "react-router-dom";

// --- IMPORT ASSETS (Giữ nguyên của bạn) ---
import lcm_album from './image/introduce/lcm_album.png';
import team_album from './image/introduce/team_album.png';
import quick_album from './image/introduce/quick_album.png';
import short_trek from './image/introduce/short_trek.png';
import back from "./image/introduce/back.png";
import HeroGallery from './hero_gallery';

const ServiceCard = ({ title, subTitle, description, image, link, label, reverse = false }) => (
  /* Sử dụng items-center và justify-center để nội dung luôn nằm giữa */
  <div className={`flex flex-col ${reverse ? 'md:flex-row-reverse' : 'md:flex-row'} items-center justify-center gap-8 md:gap-12 my-16 md:my-32 w-full`}>
    
    {/* Khối Ảnh: Giới hạn tối đa 50% chiều ngang trên Desktop */}
    <div className="w-full md:w-1/2 flex justify-center">
      <div className="relative w-full max-w-[800px]"> 
        <div className="absolute inset-0 bg-sky-100 rounded-[40px] rotate-3 -z-10 opacity-50"></div>
        <div className="overflow-hidden rounded-[30px] md:rounded-[45px] shadow-2xl border-4 border-white bg-white">
          <img src={image} alt={title} className="w-full md:h-[450px] object-cover transition-transform duration-700 hover:scale-105" />
        </div>
      </div>
    </div>

    {/* Khối Chữ: Cân bằng không gian */}
    <div className="w-full md:w-1/2 flex flex-col items-center md:items-start text-center md:text-left px-4">
      <span className="bg-orange-100 text-orange-600 px-4 py-1 rounded-full text-xs font-bold uppercase tracking-widest mb-4">
        {label}
      </span>
      <h2 className="text-5xl md:text-8xl font-black text-sky-600 leading-[0.8] mb-1">{title}</h2>
      <h3 className="text-4xl md:text-7xl font-black text-slate-800 leading-none mb-6">{subTitle}</h3>
      <p className="text-lg md:text-xl text-slate-700 italic font-medium mb-8 leading-relaxed max-w-sm">
        "{description}"
      </p>
      <NavLink to={link} className="w-full md:w-auto">
        <button className="w-full md:w-auto bg-slate-900 hover:bg-sky-600 text-white px-12 py-4 rounded-2xl font-bold transition-all shadow-xl active:scale-95 uppercase tracking-wider">
          Khám phá ngay
        </button>
      </NavLink>
    </div>
  </div>
);


export default function Introduce() {
  return (
    <div className="relative min-h-screen font-sans bg-white"
         style={{ backgroundImage: `url(${back})`, backgroundAttachment: 'fixed', backgroundSize: 'cover' }}
         >
      
      <div className="absolute inset-0 bg-white/60 backdrop-blur-[1px] z-0"></div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-12 py-10">
        
        {/* Fix khoảng cách Header: Thêm pt-20 để không bị thanh menu đè lên */}
        <section className="pt-16 md:pt-24 mb-20">
          <div className="rounded-[40px] overflow-hidden shadow-2xl border-[6px] md:border-[12px] border-white bg-white">
            <HeroGallery />
          </div>
        </section>

        {/* Nội dung chính */}
        <div className="space-y-10">
          <ServiceCard 
            title="LEARN" 
            subTitle="TREK" 
            label="Khởi đầu bản lĩnh"
            description="Quan sát tỉ mỉ, vững chãi từng li."
            image={short_trek} // Bạn có thể thay bằng asset ảnh học tập phù hợp
            link="/short" // Đường dẫn đến trang Học Leo Núi
            reverse
          />

          <ServiceCard 
            title="EASY" subTitle="TREK" label="Phổ biến nhất"
            description="Ngàn thước lên cao, ngàn thước xuống."
            image={team_album} link="/tour"
          />

          <ServiceCard 
            title="QUICK" subTitle="TREK" label="Tiết kiệm thời gian"
            description="10 phút là có một chuyến đi - Dành cho những tâm hồn ngẫu hứng."
            image={quick_album} link="/book" reverse
          />

          <ServiceCard 
            title="KEEP" subTitle="GOING" label="Tour 0 đồng"
            description="Hành trình thong dong đến đỉnh cao"
            image={lcm_album} link="/lcm"
          />

          
        </div>

        <footer className="text-center py-12 text-slate-700 font-bold text-[10px] tracking-[0.5em] uppercase">
          Leo Núi Việt Nam — Healing Sip
        </footer>
      </div>
    </div>
  );
}